import { createHighlightType } from "./HighlightType";
const AdditionHighlightSettings = {
  className: 'TrackChanges-Highlight-Addition',
  highlightType: 'addition'
};
const AdditionHighlight = createHighlightType(AdditionHighlightSettings);
export default AdditionHighlight;